import { memo } from "react"

import { Box } from "@mui/material"

import { langs } from "@uiw/codemirror-extensions-langs"
import CMEditor from "editor/CMEditor"

const CodeBlock = ({
  body,
  type,
  id,
  fullscreen,
  showSnippetCard,
}) => {
  return (
    <Box
      style={{
        overflowWrap: "break-word",
        hyphens: "auto",
        height: "30em",
        overflowY: "auto",
      }}
      component="div"
    >
      <CMEditor
        fullscreen={fullscreen}
        body={body}
        moreExtensions={[
          langs[type ? type : "javascript"]({
            jsx: true,
            typescript: true,
          }),
        ]}
        type={type}
        showSnippetCard={showSnippetCard}
        snippetId={id}
        snippetBody={body}
        editable={false}
      />
    </Box>
  )
}

export default memo(CodeBlock)
